import { mapGetters } from 'vuex';
import { successMessage, errorMessage } from '@/utils/message.js';

import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';

// person-com
// import AccountSet from './components/account-set/account-set.vue';
import PersonInfo from './components/person-info/person-info.vue';
import PersonDetailInfo from './components/person-detail-info/person-detail-info.vue';
import BankCardInfo from './components/bank-card-info/bank-card-info.vue';
import ImagesInfo from './components/images-info/images-info.vue';

// company-com
import CompanyInfo from './components/company-info/company-info.vue';
import CompanyLegalInfo from './components/company-legal-info/company-legal-info.vue';
import CompanyAuthorizerInfo from './components/company-authorizer-info/company-authorizer-info.vue';
import RegExp from '@/utils/regExp.js';

export default {
  components: {
    Header,
    Search,
    Menu,
    ProcessNavigation,
    Bottom,
    // person-com
    // AccountSet,
    PersonInfo,
    PersonDetailInfo,
    BankCardInfo,
    ImagesInfo,
    // company-com
    CompanyInfo,
    CompanyLegalInfo,
    CompanyAuthorizerInfo
  },
  data() {
    const validatePass = (rules, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入登录密码'));
      } else if (value !== this.passwordForm.password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    return {
      count: 0,
      submitForm: {files: []},
      processList: ['选择用户类型', '签订用户服务协议', '填写注册信息', '注册成功'],
      submitStatus: 'init',
      passwordForm: {
        password: '',
        confirmPassword: ''
      },
      rules: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: RegExp.pwdRegex2, message: '密码长度为6-30位的数字或字母', trigger: ['blur', 'change']}
        ],
        confirmPassword: [
          { required: true, message: '请再次输入登录密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.$store.commit('RESET_REGISTER_THIRD_STEP');
  },
  mounted() {
    if (this.count === 0 && document.documentElement.scrollTop) {
      document.documentElement.scrollTop = 0;
      this.count++;
    }
  },
  computed: {
    ...mapGetters([
      'userType',
      'isLegal'
    ])
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/register/second-step',
        query: {
          from: 'third'
        }
      });
    },
    // 组装图片上传参数
    formateFiles() {
      const imagesForm = this.$refs['imagesInfo'].form;
      let files = [];
      imagesForm.files.forEach(item => {
        const filePaths = [];
        item.filePaths.forEach(obj => {
          filePaths.push(obj.sourceImgUrl);
        });
        if (filePaths && filePaths.length) {
          files.push({
            imgEnumType: item.projectFileType,
            urls: [...filePaths]
          });
        }
      });
      if (this.isLegal) {
        const assignorIDCardFront = files.find(v => v.imgEnumType === 'ID_CARD_FRONT');
        const assignorIDCardBack = files.find(v => v.imgEnumType === 'ID_CARD_BACK');
        files = [...files, { imgEnumType: 'ASSIGNOR_ID_CARD_FRONT', urls: assignorIDCardFront.urls }, { imgEnumType: 'ASSIGNOR_ID_CARD_BACK', urls: assignorIDCardBack.urls }];
      }
      return files;
    },
    // 法人表单存储时会调用
    storeLegalForm() {
      this.$refs['companyAuthorizerInfo'].copyFormData();
    },

    validatePasswordForm() {
      let isValid = false;
      this.$refs['passwordForm'].validate(valid => {
        isValid = valid;
      });
      return isValid;
    },
    // 校验表单
    validateForm() {
      const isPasswordFormValidate = this.validatePasswordForm();
      // const isAccountSetValidate = this.$refs['accountSet'].validateForm();
      const isPersonInfoValidate = this.$refs['personInfo'] && this.$refs['personInfo'].validateForm();
      const isPersonDetailInfoValidate = this.$refs['personDetailInfo'] && this.$refs['personDetailInfo'].validateForm();
      const isBankCardInfoValidate = this.$refs['bankCardInfo'].validateForm();
      const isImagesInfoValidate = this.$refs['imagesInfo'].validateForm();
      // 企业基本信息
      const isCompanyInfoValidate = this.$refs['companyInfo'] && this.$refs['companyInfo'].validateForm();
      // 企业法人信息
      const isCompanyLegalInfoValidate = this.$refs['companyLegalInfo'] && this.$refs['companyLegalInfo'].validateForm();
      // 授权人信息
      const isCompanyAuthorizerInfoValidate = this.$refs['companyAuthorizerInfo'] && this.$refs['companyAuthorizerInfo'].validateForm();
      // 授权人验证码
      const isCompanyAuthorizerSmsCodeValidate = this.$refs['imagesInfo'].validateCodeForm();
      if (isBankCardInfoValidate && isImagesInfoValidate) {
        if (this.userType === 1 && isPersonInfoValidate && isPersonDetailInfoValidate && isPasswordFormValidate) {
          return true;
        }
        if (this.userType !== 1 && isCompanyInfoValidate && isCompanyLegalInfoValidate && isCompanyAuthorizerInfoValidate && isCompanyAuthorizerSmsCodeValidate && isPasswordFormValidate) {
          return true;
        }
      }
      return false;
    },
    submit() {
      if(!this.validateForm()) { return;}
      if (this.submitStatus === 'ongoing') {return;}
      const files = this.formateFiles();
      let accForm = JSON.parse(JSON.stringify(this.$refs['bankCardInfo'].form));
      delete accForm.taxNo;
      this.submitForm = {
        files: files,
        type: this.userType,
        // ...this.$refs['accountSet'].form,
        accForm: accForm
      };
      if (this.userType === 1) {
        this.submitForm.personForm = {
          ...this.$refs['personInfo'].form,
          ...this.$refs['personDetailInfo'].form,
          verifyCode: this.$refs['imagesInfo'].codeForm.assignorCode
        };
      } else {
        this.submitForm.companyForm = {
          ...this.$refs['companyInfo'].form,
          ...this.$refs['companyLegalInfo'].form,
          ...this.$refs['companyAuthorizerInfo'].form,
          ...this.$refs['imagesInfo'].codeForm,
          type: this.userType,
          taxNo: this.$refs['bankCardInfo'].form && this.$refs['bankCardInfo'].form.taxNo
        };
      }
      this.submitForm.accForm.accBankCardNo = this.submitForm.accForm.accBankCardNo.replace(/\s/g, '');
      this.submitStatus = 'ongoing';
      this.registerUser();
    },
    // 注册
    registerUser() {
      this.$store.dispatch('registerUser', {...this.submitForm, password: this.passwordForm.password }).then(res => {
        if (res.code === '0') {
          this.submitStatus = 'success';
          successMessage('注册成功');
          this.$router.push('/register/four-step');
        } else if (res && res.reason) {
          this.submitStatus = 'failed';
          errorMessage(res && res.reason);
        } else {
          this.submitStatus = 'failed';
          errorMessage('注册失败，请重试');
        }
      }, error => {
        this.submitStatus = 'failed';
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('注册失败，请重试');
        }
      });
    }
  }

};
